@if (state() === "loading") {
  <app-loading />
}

@if (state() === "error") {
  <app-error-data [title]="errorMessage()" />
}

@if (state() === "success") {
  <app-tables
    [headerItems]="headerItems"
    [rows]="rows()"
    [currentActions]="currentActions"
    (actionTrigger)="handleAction($any($event))"
    [isFiltersApplied]="isFiltersApplied()"
    [emptyFilterTitle]="
      isArabic()
        ? 'لم يتم العثور على عروض تطابق الفلاتر. حاول تعديل معايير البحث.'
        : 'No offers found matching your filters. Try adjusting your search criteria.'
    "
    [emptyContentTitle]="isArabic() ? 'لا توجد عروض متاحة' : 'No offers available'"
    [emptyContentDescription]="isArabic() ? 'لا توجد عروض في النظام.' : 'No offers found in the system.'" />
}
